/**
 * @generated SignedSource<<8cf4cc6e8a2b8580c52e3b5ab915e757>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveKind = "TAR" | "ZIP";
import { Url } from "@/common/relayCustomScalar";
export type ProjectDownloadButtonDownloadArchiveQuery$variables = {
  archKind: ArchiveKind;
  id: string;
};
export type ProjectDownloadButtonDownloadArchiveQuery$data = {
  readonly node: {
    readonly downloadUrl?: Url;
  };
};
export type ProjectDownloadButtonDownloadArchiveQuery = {
  response: ProjectDownloadButtonDownloadArchiveQuery$data;
  variables: ProjectDownloadButtonDownloadArchiveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "archKind"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "archKind",
          "variableName": "archKind"
        }
      ],
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    }
  ],
  "type": "ProjectVersionFile",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectDownloadButtonDownloadArchiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "ProjectDownloadButtonDownloadArchiveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bd15349c884e595ce1a8eef0a0c88e7c",
    "id": null,
    "metadata": {},
    "name": "ProjectDownloadButtonDownloadArchiveQuery",
    "operationKind": "query",
    "text": "query ProjectDownloadButtonDownloadArchiveQuery(\n  $id: ID!\n  $archKind: ArchiveKind!\n) {\n  node(id: $id) {\n    __typename\n    ... on ProjectVersionFile {\n      downloadUrl(archKind: $archKind)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ff603168025685125cd9307da3bdd19";

export default node;
